function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    style: {
      fill: "#f5ac37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38 24.88v-5.53c0-.13 0-.15-.16-.15H6.05c-.12 0-.17 0-.17-.16v-1.9H8.2c.13 0 .18 0 .18-.17v-1.88c0-.12 0-.15-.16-.15H6.05c-.12 0-.17 0-.17-.16v-1.76c0-.11 0-.14.16-.14h2.15c.15 0 .19 0 .19-.19V7.3c0-.16 0-.2.2-.2h7.5a11.15 11.15 0 0 1 1.62.18 9.78 9.78 0 0 1 3.13 1.16 8.9 8.9 0 0 1 1.76 1.36 9.74 9.74 0 0 1 1.07 1.33 7.87 7.87 0 0 1 .78 1.53.26.26 0 0 0 .3.21h1.79c.23 0 .23 0 .24.22v1.64c0 .16-.06.2-.22.2h-1.38c-.14 0-.18 0-.17.18a10.17 10.17 0 0 1 0 1.83c0 .17 0 .19.19.19h1.58c.07.09 0 .18 0 .27a2 2 0 0 1 0 .35v1.21c0 .17-.05.22-.2.22h-1.89a.25.25 0 0 0-.29.19 8 8 0 0 1-2.1 3.06 12.21 12.21 0 0 1-1.07.86c-.4.23-.79.47-1.2.66a10.81 10.81 0 0 1-2.36.75 12.25 12.25 0 0 1-2.34.19H8.38Zm13.81-5.67a2.18 2.18 0 0 0-.51 0H10.59c-.15 0-.2 0-.2.2v3.47c0 .16 0 .2.2.2h5.12a2.57 2.57 0 0 0 .73-.05 7.67 7.67 0 0 0 2.17-.48 4 4 0 0 0 .73-.34s.05 0 .07 0a6.5 6.5 0 0 0 2.79-2.81s.07-.15-.01-.19Zm0-6.36a.19.19 0 0 0 0-.14 3.94 3.94 0 0 0-.36-.63 5.13 5.13 0 0 0-.74-.93 2.45 2.45 0 0 0-.46-.45 7.18 7.18 0 0 0-3-1.52 7.45 7.45 0 0 0-1.7-.18h-5.37c-.15 0-.17.06-.17.19v3.55c0 .15 0 .19.19.19h11.54s.1-.02.12-.08Zm-5.6 4.28h6.08c.13 0 .19 0 .2-.17a11.55 11.55 0 0 0 0-1.86c0-.12-.06-.17-.19-.17h-12.1c-.15 0-.19.05-.19.19v1.78c0 .23 0 .23.24.23Z",
    style: {
      fill: "#fefefd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDai);
export default __webpack_public_path__ + "static/media/dai.f665a8d33baef697fbadfb20858be440.svg";
export { ForwardRef as ReactComponent };